import PlusCircle from "../Components/plusCircle";
import { useGlobalContext } from "../Context/GlobalContext";
import { Profile } from "../Types";
import { Grid2 as Grid } from '@mui/material';

const ProfileItem = ({
  profile,
  active,
  onProfileClick,
  onProfileEdit,
  uploadedProfile
}: {
  profile: Profile;
  active?: boolean;
  onProfileClick: Function;
  onProfileEdit?: Function;
  uploadedProfile?: string;
}) => {
  const { getThemeStyles, getThemeImage } = useGlobalContext();
  const styles = getThemeStyles();

  const Ellipse = ({active} : {active: Boolean}) => {
    return (
      <img 
        src={getThemeImage(`Ellipse_${active ? 'in' : ''}active`)} 
        alt="Live" 
        style={{ padding: '0 10px', width: '20px' }} 
        className="pulse"
      />  
    )
  }
  
  return (
    <div 
      onClick={() => onProfileClick()}
      className="profile-item border" 
      style={{ 
        cursor: 'pointer', 
        backgroundColor: active ? styles['--theme-color'] : 'transparent',
        opacity: profile.name === "NEW PROFILE" ? 0.25 : 1, 
        ...(profile.name === "NEW PROFILE" ? { padding: '5px' } : {}),
      }}
    >
      <Grid container style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        { profile.name === "NEW PROFILE" && <div className="profile-icon">          
          <div style={{ width: "25px", marginTop: '7px' }}>
            <PlusCircle width="100%"/>
          </div>
        </div>}
        <Grid
          size={{xl: 8, xs: profile.name === "NEW PROFILE" ? 8 : 12}} 
          className="profile-text" 
          style={{ 
            textAlign: !active ? "center" : "left", 
            display: "flex", 
            justifyContent: "left", 
            alignItems: "center",
            color: active ? styles['--theme-bg-color'] : styles['--theme-color'],
          }}
        >
          {profile.name}
          {
            profile.name !== "NEW PROFILE" && 
            <span 
              className="material-symbols-outlined" 
              style={{
                fontSize: "20px", 
                marginLeft: '10px', 
                cursor: 'pointer', 
                color: active ? styles['--theme-bg-color'] : styles['--theme-color']
              }}
              onClick={(e) => {
                e.stopPropagation();
                onProfileEdit && onProfileEdit();
              }}
            >
              edit_square
            </span>
          } 
        </Grid>
        {
          uploadedProfile === profile.id.toString() && 
          <Grid 
            size={{xl: 4, xs: profile.name === "NEW PROFILE" ? 4 : 12}} 
          >
            <div
              style={{
                margin: '0 5px', 
                display: 'flex',
                paddingRight: '5px',
                color: active ? styles['--theme-bg-color'] : styles['--theme-color'],
              }}
            >
              <div className="knog-font">LIVE</div>
              <Ellipse active={!active}/>
            </div>
          </Grid>
        }
      </Grid>
    </div>
  );
};

export default ProfileItem;
